import { PropsWithChildren } from 'react';
import { ReflagProvider } from '@reflag/react-sdk';
import useAuth from 'hooks/auth/useAuth';
import NewLayout from './NewLayout';
import OldLayout from './OldLayout';
import useIsNewLayoutPage from 'hooks/ui/useIsNewLayoutPage';
import LayoutContextProvider from 'contexts/LayoutContext';
import useAvailableVehicles from 'hooks/lp/data/vehicle/useAvailableVehicles';
import { AdminUserRealm } from 'further-types/admin-user';

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const { realm, actionableError, user } = useAuth();
  const isNewLayoutPage = useIsNewLayoutPage();
  const { availableVehicles, isLoading } = useAvailableVehicles(realm);

  if (actionableError) {
    return <>{children}</>;
  }

  if (!realm || isLoading) {
    return null;
  }

  const reflagContext = {
    company:
      realm === AdminUserRealm.Super
        ? { id: 'Further', realm: AdminUserRealm.Super, name: 'Further' }
        : {
            id: user.data?.firm?._id,
            realm,
            name: user.data?.firm?.firmName,
          },
    user: {
      id: user.data?._id,
      email: user.data?.email,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
    },
  };

  return (
    <ReflagProvider
      publishableKey={process.env.REACT_APP_REFLAG_KEY!}
      context={reflagContext}
    >
      <LayoutContextProvider availableVehicles={availableVehicles}>
        {isNewLayoutPage ? (
          <NewLayout>{children}</NewLayout>
        ) : (
          <OldLayout>{children}</OldLayout>
        )}
      </LayoutContextProvider>
    </ReflagProvider>
  );
};

export default Layout;
